/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} File_Import_Next_AriaInputs */

const en_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceed to selected import flow`)
};

const fr_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceed to selected import flow`)
};

const de_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Fahren Sie mit dem ausgewählten Importvorgang fort.`)
};

const it_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Procedi al flusso di importazione selezionato`)
};

const ru_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Перейти к выбранному процессу импорта`)
};

const es_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Proceder al flujo de importación seleccionado`)
};

const zh_cn2_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`继续执行选定的导入流程`)
};

const ja_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選択したインポートフローに進む`)
};

const hi_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`चयनित आयात प्रवाह पर आगे बढ़ें`)
};

const pt_pt2_file_import_next_aria = /** @type {(inputs: File_Import_Next_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prossiga para o fluxo de importação selecionado.`)
};

/**
* | output |
* | --- |
* | "Proceed to selected import flow" |
*
* @param {File_Import_Next_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const file_import_next_aria = /** @type {((inputs?: File_Import_Next_AriaInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<File_Import_Next_AriaInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_file_import_next_aria(inputs)
	if (locale === "de") return de_file_import_next_aria(inputs)
	if (locale === "it") return it_file_import_next_aria(inputs)
	if (locale === "ru") return ru_file_import_next_aria(inputs)
	if (locale === "es") return es_file_import_next_aria(inputs)
	if (locale === "zh-CN") return zh_cn2_file_import_next_aria(inputs)
	if (locale === "ja") return ja_file_import_next_aria(inputs)
	if (locale === "hi") return hi_file_import_next_aria(inputs)
	if (locale === "pt-PT") return pt_pt2_file_import_next_aria(inputs)
	return en_file_import_next_aria(inputs)
});